import React from 'react';
import { DialogActions } from '@mui/material';
import CustomButton from '../../../../../../../../../../../../../lib/designSystem/Button';
import SimulationDoneFrozen from '../../../../../../../../../common/SimulationDoneFrozen';
import InforPreview from '../../../../../../../../../common/InforPreview';

const ShoppingCartFactoringRejected = (props: any) => {
  const { setOpenShoppingcart, selectedRequest } = props;

  const infoDiv = (
    <InforPreview
      requestType="factoring"
      type="Sent"
      status="Rechazada"
      selectedRequest={selectedRequest}
    />
  );

  return (
    <div>
      <div>
        <SimulationDoneFrozen
          selectedRequest={selectedRequest}
          infoDiv={infoDiv}
        />
        <DialogActions>
          <CustomButton
            onClick={() => setOpenShoppingcart(false)}
            color="secondary"
          >
            Salir
          </CustomButton>
        </DialogActions>
      </div>
    </div>
  );
};

export default ShoppingCartFactoringRejected;
